import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDefaultDateRange, normalizeDateToUTC } from "../utils/dateUtils";

const DestinationDetail: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    const country = location.pathname.split("/").pop();
    if (!country) return;

    const [checkIn, checkOut] = getDefaultDateRange();
    const dateFrom = normalizeDateToUTC(checkIn);
    const dateTo = normalizeDateToUTC(checkOut);

    navigate(
      `/search-results?country=${country}&date_from=${encodeURIComponent(dateFrom)}&date_to=${encodeURIComponent(dateTo)}&type=`,
      { replace: true },
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default DestinationDetail;
